
// --------------------------- 定数 ---------------------------

// テスト用：wiremockに向けての送信用API_URL
const WIREMOCK_PATH_WISHLIST = 'http://localhost:8081/api/wishlist';
// 本番用：SNAPECに向けての送信用API_URL
const APP_PROXY_PATH_WISHLIST = 'https://stg-crestbridge.myshopify.com/apps/WishlistProduct';

// お気に入り商品取得APIエンドポイント
const GetWishlistProduct = '/GetWishlistProduct/';
// お気に入り商品更新APIエンドポイント
const UpdateWishlistProduct = '/UpdateWishlistProduct/';

// SNAPEC_API用接続元 ( 1:SOS 2:CB )
const SNAPECApiStore = '2';

// -----------------------------------------------------------

let isNavigating = false;

// 画面遷移イベントを監視
window.addEventListener('pagehide', function () {
  isNavigating = true;
});
window.addEventListener('beforeunload', function () {
  isNavigating = true;
});

// ----------------------- SNAPEC API ------------------------
// お気に入り商品一覧取得APIの汎用関数
async function fetchWishlistAPI(endpoint, body) {
  try {
    const response = await fetch('https://' + STORE_DOMAIN + APP_PROXY_SNAPEC_PATH + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    if (response.status === 200) {
      const data = await response.json();
      return data;
    } else {
      const errorText = await response.text();
      throw new Error(`HTTP Error ${response.status}: ${errorText}`);
    }
  } catch (error) {
    // ブラウザバック中に発生したエラーは無視する
    if (isNavigating) {
      return null;
    } else {
      console.error('Error fetching data:', error);
      throw error;
    }
  }
}

// お気に入り商品一覧取得API(商品指定なし)
async function getCustomerWishlists(customerId, start, count) {
  return fetchWishlistAPI(GetWishlistProduct, {
    member_no: customerId,
    source_host: SNAPECApiStore,
    offset: start,
    limit: count
  });
}

// お気に入り商品一覧取得API(商品指定あり)
async function getCustomerWishlist(customerId, productHandle) {
  return fetchWishlistAPI(GetWishlistProduct, {
    member_no: customerId,
    source_host: SNAPECApiStore,
    product_id: productHandle
  });
}

// お気に入り更新API
async function UpdateCustomerWishlist(customerId, variantSkuList, registerType) {
  return fetchWishlistAPI(UpdateWishlistProduct, {
    member_no: customerId,
    variant_sku_list: variantSkuList,
    register_type: registerType
  });
}

// -----------------------------------------------------------

// ----------------------- Shopify API ------------------------

// shopify商品情報取得クエリ
const getProductDetailsQuery = `
query MyQuery($id: ID!) {
  node(id: $id) {
    ... on ProductVariant {
      product {
        id
        handle
        title
        tags
        vendor
        images(first: 1) {
          edges {
            node {
              url
            }
          }
        }
        initialstartFilter: metafield(key: "filter", namespace: "initialstart") {
          key
          value
        }
        saleStart: metafield(key: "start", namespace: "sale") {
          key
          value
        }
        saleEnd: metafield(key: "end", namespace: "sales") {
          key
          value
        } 
      }
      price {
        amount
        currencyCode
      }
      compareAtPrice {
        amount
        currencyCode
      }
      id
      sku
      selectedOptions {
        name
        value
      }
      image {
        url
      }
      quantityAvailable
      metafield(key: "status", namespace: "sales") {
        key
        value
      }
    }
  }
}
`;

// shopify商品取得処理
async function fetchProductDetails(productId) {
  try {
    // 引数確認
    if (!productId) {
      return null;
    }

    // 商品情報取得処理
    const shopDomain = document.querySelector('#shopDomain');
    const response = await fetch(`https://${shopDomain.value}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': document.querySelector('#storeFrontAccessToken').value
      },
      body: JSON.stringify(
        {
          query: getProductDetailsQuery,
          variables: {
            id: productId
          }
        }
      )
    });
    const responseData = await response.json();
    // レスポンスから商品情報を取得
    const variant = responseData.data?.node;
    if (!variant) {
      console.error(`お気に入り商品情報取得ストアフロントAPIレスポンスerror: No product details found: productID : ${productId}`);
      return;
    }

    // 応答値の設定
    let productDetails = {
      product_id: variant.product.id, // 商品:ID
      product_handle: variant.product.handle, // 商品:handle
      product_title: variant.product.title, // 商品:タイトル
      product_tags: variant.product.tags, // 商品:タグ
      product_vendor: variant.product.vendor, // 商品:販売元
      product_images: variant.product.images.edges[0]?.node.url, // 商品:写真(1枚目)
      product_initialstartFilter: variant.product.initialstartFilter, // 商品:初回販売開始日(並び替え用)
      product_saleStart: variant.product.saleStart, // 商品:セール販売開始日時
      product_saleEnd: variant.product.saleEnd, // 商品:セール終了開始日時
      variant_price: variant.price, // 商品variant:価格
      variant_id: variant.id, // 商品variant:ID
      variant_selectedOptions: variant.selectedOptions, // 商品variant:オプション(カラー/サイズ)
      variant_sku: variant.sku, // 商品variant:SKU
      variant_compareAtPrice: variant.compareAtPrice,// 商品variant:希望小売価格(値下げ前価格)
      variant_imageUrl: variant.image.url,// 商品variant:写真(1枚目)
      variant_quantity: variant.quantityAvailable, // 商品variant:在庫数
      variant_metafield: variant.metafield // 商品variant:メタフィールド (販売ステータス)
    };
    return productDetails;

  } catch (error) {
    console.error('お気に入り商品情報取得ストアフロントAPIエラー:', error);
    throw error;
  }
}

// -----------------------------------------------------------

// ------------------------- 処理部品 -------------------------

// 価格抽出処理
function extractNumbers(str) {
  return str.replace(/[^0-9]/g, '');
}

// 数値が13桁であるかどうかをチェックする関数
function is13Digits(number) {
  // 数値を文字列に変換
  const numStr = number.toString();

  // 正規表現パターンを作成
  const pattern = /^\d{13}$/;

  // 正規表現のテストメソッドを使用してチェックし、結果を返す
  return pattern.test(numStr);
}

// -----------------------------------------------------------